import React from 'react'
import PropTypes from 'prop-types'
// eslint-disable-next-line
import ImageDropArea from './ImageDropArea'

const NodeContainer = (props) => {
  const { divProps, onDropImage, rowCount } = props
  return (
    <div className={`nodeContainer node${rowCount}x2`} {...divProps}>
      <ImageDropArea onDrop={onDropImage}>
        <div className="nodeContainerContent">{props.children}</div>
      </ImageDropArea>
      <div className="nodeContainerOverlay" />
    </div>
  )
}

NodeContainer.propTypes = {
  divProps: PropTypes.object,
  onDropImage: PropTypes.func,
  rowCount: PropTypes.number,
  children: PropTypes.element.isRequired,
}

export default NodeContainer
